import React, {
  useContext,
  useEffect,
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { useForm, Controller } from "react-hook-form";
import { PhrasesContext } from "../../context/phrasesContext";
import Select from "react-select";
import { Disclosure } from "@headlessui/react";
import { components } from "react-select";
import {
  getCaseTypes,
  getCourts,
  getPartyTypes,
  getGetInquiryOptions,
  getServiceCategories,
  getServiceClassfications,
  getSubServiceCategories,
  UploadCourtDocument,
  addRequests,
  getsub_categories,
  getService_Classifications,
  getCourts_Category,
} from "../../services/Common";
import SharedModal from "../happiness/SharedModal";
import { Link, useNavigate } from "react-router-dom";
import SharesAndBonds from "./SharesAndBonds";
import { Loader } from "../utils";
import AddLocation from "./AddLocation";
import CaseBasicInfo from "./CaseBasicInfo";
import DisclosureSection from "./DisclosureSection";

const CaseDetailsUpdated = forwardRef(
  (
    {
      disclosures,
      setDisclosures,
      addNewDisclosure,
      requesterInfo,
      setLoading,
      handleSubmitAll,
      submitAllRequests,
      setSubmitAllRequests,
      setSomethingWentWrong,
      setIsSubmitting,
      parentDisclosureRef,
      scrollToNewDisclosure,
      setScrollToNewDisclosure,
      setDisclosureData,
      disclosureData,
      setShowMap,
      handleLocationSelect,
      openMapForDisclosure,
      setIsSubmittingDocuments,
    },
    ref,
  ) => {
    const maxOffset = 60;
    const inputFile = useRef(null);
    const [enPhrase, arPhrase] = useContext(PhrasesContext);
    const [lang, setLang] = useState("");
    const [requestId, setRequestId] = useState(
      localStorage.getItem("requestId"),
    );
    const [courts, setCourts] = useState([]);
    const [caseTypes, setCaseTypes] = useState([]);
    const [years, setYears] = useState([]);
    const [partyTypes, setPartyTypes] = useState([]);
    const [mobileNumber, setMobileNumber] = useState({
      contactno: "",
      country_code: "+971",
    });
    const [serviceCaregories, setServiceCaregories] = useState([]);
    const [states, setStates] = useState([]);
    const [subServiceCaregories, setSubServiceCaregories] = useState([]);
    const [catigories, setCatigories] = useState([]);
    const [keyValue, setKeyValue] = useState("");
    const [isChecked, setIsChecked] = useState(false);
    const [InquiryOptions, setInquiryOptions] = useState([]);
    const [file, setFile] = useState("");
    const [uploadedFile, setUploadedFile] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isSearchable, setIsSearchable] = useState(true);
    const [isRtl, setIsRtl] = useState(false);
    const [showImage, setShowImage] = useState(false);
    const [displayedImage, setDisplayedImage] = useState(null);
    const navigate = useNavigate();
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedDisclosureId, setSelectedDisclosureId] = useState(null);
    const [openDisclosures, setOpenDisclosures] = useState({});
    const disclosureRefs = useRef({});
    const lastDisclosureRef = useRef(null);
    const [dismissedTooltips, setDismissedTooltips] = useState({});
    const [dismissedSharesAndBonds, setDismissedSharesAndBonds] = useState({});
    const [seperateRequests, setSeperateRequests] = useState({});
    const [disabledClassifications, setDisabledClassifications] = useState({});

    const [disabledSuborderTypes, setDisabledSuborderTypes] = useState({});

    const [selectedUploadFile, setSelectedUploadFile] = useState({});
    const [previewDisclosureId, setPreviewDisclosureId] = useState(null);
    const [uploadingDisclosures, setUploadingDisclosures] = useState({});
    const [sharedValues, setSharedValues] = useState({
      court: null,
      caseType: null,
      caseNumber: "",
      caseYear: null,
      customer: null,
      country_code: "+971",
      mobile: "",
      email: "",
    });

    const [loadingClassifications, setLoadingClassifications] = useState({});
    const [loadingSuborderTypes, setLoadingSuborderTypes] = useState({});

    const {
      register,
      formState: { errors },
      handleSubmit,
      setValue,
      clearErrors,
      control,
      watch,
      setError,
      trigger,
      unregister,
      getValues,
    } = useForm({
      mode: "onSubmit", // ✅ Validate only on submission
      shouldUnregister: true, // ✅ retain form data and validation for hidden fields
      defaultValues: {
        InquiryOption: 0, // ✅ Default value for dropdowns
      },
    });

    const selectedorderType = watch("orderType");

    const isMobileDevice = () =>
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      );

    useEffect(() => {
      const lang = window.localStorage.getItem("lang");
      const storedRequestId = localStorage.getItem("requestId");
      let currentLang = lang;
      if (lang === "en") {
        document.body.dir = "ltr";
        setLang("en");
        currentLang = "en";
      } else {
        document.body.dir = "rtl";
        setLang("ar");
        currentLang = "ar";
      }
      const year = new Date().getFullYear();
      setYears(Array.from(new Array(maxOffset), (val, index) => year - index));
      if (!storedRequestId) {
        getCourtsService(currentLang);
      }
      // getCaseTypesService(currentLang);
      if (storedRequestId) {
        getServiceCategoriesService(currentLang);
        getCourts_CategoryService(currentLang, storedRequestId);
      }

      // getSubServiceCategoriesService(currentLang);
      getPartyTypesService(currentLang);
      getGetInquiryOption(currentLang);
    }, []);

    useEffect(() => {
      setDisclosureData((prevData) => {
        const updatedData = { ...prevData };

        disclosures.forEach((disclosure) => {
          if (!updatedData[disclosure.id]) {
            // Only add a new, clean entry if it doesn't exist yet
            updatedData[disclosure.id] = {
              orderType: null,
              classificationType: null,
              suborderType: null,
              inquiryOption: null,
              location: null,
              locationName: null,
              makaniLocation: null,
              fileUpload: null,
              subjectDocuments: [],
            };
          }
        });

        return updatedData;
      });

      // 2. Open any new disclosure by default
      setOpenDisclosures((prev) => {
        const updated = { ...prev };
        disclosures.forEach((disclosure) => {
          if (!(disclosure.id in updated)) {
            updated[disclosure.id] = true; // open if newly added
          }
        });
        return updated;
      });

      clearErrors();
    }, [disclosures]);

    useEffect(() => {
      const storedRequestId = localStorage.getItem("requestId");

      if (storedRequestId && serviceCaregories.length > 0) {
        // Find the matching orderType
        const selectedOrderType = serviceCaregories.find(
          (category) => category.id.toString() === storedRequestId,
        );

        console.log("selectedOrderType", selectedOrderType);

        if (selectedOrderType) {
          console.log("Auto-selected orderType:", selectedOrderType);

          // Update form state for each disclosure
          disclosures.forEach(async (disclosure) => {
            setValue(`orderType-${disclosure.id}`, selectedOrderType, {
              shouldValidate: true, // ✅ Ensures validation runs
            });

            // Update disclosureData state
            setDisclosureData((prevData) => ({
              ...prevData,
              [disclosure.id]: {
                ...prevData[disclosure.id],
                orderType: selectedOrderType,
              },
            }));

            // Trigger orderType change handler to update dependent fields
            handleOrderTypeChange(disclosure.id, selectedOrderType);

            // ✅ Manually trigger validation to remove any errors
            await trigger(`orderType-${disclosure.id}`);
          });

          clearErrors(); // ✅ Clears all validation errors
        }
      }
    }, [serviceCaregories, subServiceCaregories]); // Runs when serviceCaregories is loaded

    console.log("selectedorderType", selectedorderType);
    console.log("Form errors:", errors);

    useEffect(() => {
      setStates(
        subServiceCaregories.filter((ctr) => ctr.serviceId === requestId),
      );
      clearErrors("orderType");
      console.log("State", states);
    }, []);

    useEffect(() => {
      if (scrollToNewDisclosure && lastDisclosureRef.current) {
        // Wait for DOM updates + disclosure expansion
        setTimeout(() => {
          requestAnimationFrame(() => {
            const el = lastDisclosureRef.current;
            if (el) {
              // Scroll slightly above the disclosure to reveal the full body
              const yOffset = -40; // adjust if you have a sticky header
              const y =
                el.getBoundingClientRect().top + window.pageYOffset + yOffset;
              window.scrollTo({ top: y, behavior: "smooth" });
            }

            setScrollToNewDisclosure(false);
          });
        }, 200); // Wait enough for disclosure to mount & animate
      }
    }, [disclosures, scrollToNewDisclosure]);

    const getCourtsService = (currentLang) => {
      return getCourts(currentLang).then((res) => {
        setCourts(res);
      });
    };

    // const getCaseTypesService = (currentLang) => {
    //   return getCaseTypes(currentLang).then((res) => {
    //     setCaseTypes(res);
    //   });
    // };

    const optionsYear = years.map((year) => ({
      id: year.toString(),
      name: year,
    }));

    const getPartyTypesService = (currentLang) => {
      return getPartyTypes(currentLang).then((res) => {
        setPartyTypes(res);
      });
    };

    const getServiceCategoriesService = (currentLang) => {
      return getServiceCategories(currentLang).then((res) => {
        setServiceCaregories(res);
      });
    };

    // const getSubServiceCategoriesService = (currentLang) => {
    //   return getSubServiceCategories(currentLang).then((res) => {
    //     setSubServiceCaregories(res);
    //   });
    // };

    const getGetInquiryOption = (currentLang) => {
      return getGetInquiryOptions(currentLang).then((res) => {
        setInquiryOptions(res);
      });
    };

    const getCourts_CategoryService = (currentLang, requestId) => {
      return getCourts_Category(currentLang, requestId).then((res) => {
        setCourts(res);
      });
    };

    function customTheme(theme) {
      return {
        ...theme,
        colors: {
          ...theme.colors,
          primary25: "#F9F7ED",
          primary: "#B68A35",
          neutral0: "white", // Ensure menu background stays white
        },
      };
    }

    const customStyles = {
      control: (base, state) => ({
        ...base,
        background: state.isDisabled ? "#EFEFEF" : "#fff", // gray background when disabled
        borderRadius: 4,
        "*": {
          boxShadow: "none !important",
        },
        backgroundColor: state.isFocused ? "#fffff0" : "#fff",
      }),
      menu: (base) => ({
        ...base,
        borderRadius: 0,
        marginTop: 0,
        height: "auto",
        overflow: "auto",
      }),
      menuList: (base) => ({
        ...base,
        padding: 0,
        backgroundColor: "#fff", // Keep background white to avoid overriding
        maxHeight: "200px",
      }),
      option: (base, { isSelected, isFocused }) => ({
        ...base,
        backgroundColor: isSelected
          ? "#B68A35"
          : isFocused
            ? "#F9F7ED"
            : "white",
        color: isSelected ? "white" : "black",
        ":hover": {
          backgroundColor: isSelected ? "#B68A35" : "#F9F7ED",
          color: "black",
        },
      }),
      indicatorSeparator: (base) => ({
        ...base,
        display: "none",
      }),
    };

    const handleCheckboxChange = (event) => {
      setIsChecked(event.target.checked);
    };

    const formatOptionLabel = ({ name, label, customAbbreviation }) => (
      <div style={{ display: "flex" }}>
        <div className="text-[0.875rem] font-Almarai ">{name}</div>
      </div>
    );

    const removeDisclosure = (id) => {
      const cloneId = `${id}-copy`;

      // Unregister original fields
      unregister(`orderType-${id}`);
      unregister(`classificationType-${id}`);
      unregister(`suborderType-${id}`);
      unregister(`inquiryOption-${id}`);
      unregister(`fileupload-${id}`);

      // Unregister cloned fields (if they exist)
      unregister(`orderType-${cloneId}`);
      unregister(`classificationType-${cloneId}`);
      unregister(`suborderType-${cloneId}`);
      unregister(`inquiryOption-${cloneId}`);
      unregister(`fileupload-${cloneId}`);

      // Remove original disclosure from UI list
      setDisclosures((prevDisclosures) =>
        prevDisclosures.filter((disclosure) => disclosure.id !== id),
      );

      // Clean up disclosureData (original + clone)
      setDisclosureData((prevData) => {
        const updated = { ...prevData };
        delete updated[id];
        delete updated[cloneId];
        return updated;
      });

      // Clean up openDisclosures map
      setOpenDisclosures((prev) => {
        const updated = { ...prev };
        delete updated[id];
        return updated;
      });

      // Clean up separateRequests map
      setSeperateRequests((prev) => {
        const updated = { ...prev };
        delete updated[id];
        return updated;
      });

      // Optional: cleanup tooltips or modals if you're tracking them per ID
      setDismissedTooltips?.((prev) => {
        const updated = { ...prev };
        delete updated[id];
        return updated;
      });

      setDismissedSharesAndBonds?.((prev) => {
        const updated = { ...prev };
        delete updated[id];
        return updated;
      });
    };

    console.log("Updated disclosures:", disclosures);
    console.log("Updated disclosureData:", disclosureData);

    // Function to update individual disclosure's state
    const updateDisclosureData = (id, field, value) => {
      setDisclosureData((prevData) => ({
        ...prevData,
        [id]: {
          ...prevData[id],
          [field]: value,
        },
      }));
    };

    const [classificationOptions, setClassificationOptions] = useState({});
    const [suborderTypeOptions, setSuborderTypeOptions] = useState({});

    // FULL: handleOrderTypeChange
    // const handleOrderTypeChange = async (id, selectedOption) => {
    //   if (!selectedOption) return;

    //   const categoryId = selectedOption.id;
    //   const courtId = sharedValues?.court?.id;

    //   // Reset dependent values (form + state)
    //   setValue(`classificationType-${id}`, null);
    //   setValue(`suborderType-${id}`, null);

    //   setDisclosureData((prev) => ({
    //     ...prev,
    //     [id]: {
    //       ...prev[id],
    //       orderType: selectedOption,
    //       classificationType: null,
    //       suborderType: null,
    //     },
    //   }));

    //   // Reset dropdown options + disable flags
    //   setClassificationOptions((prev) => ({ ...prev, [id]: [] }));
    //   setSuborderTypeOptions((prev) => ({ ...prev, [id]: [] }));

    //   setDisabledClassifications((prev) => ({ ...prev, [id]: false }));
    //   setDisabledSuborderTypes((prev) => ({ ...prev, [id]: false }));

    //   // Court is required
    //   if (!courtId) return;

    //   try {
    //     // 1) getsub_categories
    //     const res = await getsub_categories(lang, categoryId, courtId);
    //     const subCats = Array.isArray(res)
    //       ? res
    //       : res?.data || res?.result || [];

    //     // Set classification options
    //     setClassificationOptions((prev) => ({ ...prev, [id]: subCats }));

    //     // If only 1 classification -> auto select + disable + fetch suborder types
    //     if (subCats.length === 1) {
    //       const singleClassification = subCats[0];
    //       const subCategoryId = singleClassification.id;

    //       // auto-select classificationType
    //       setValue(`classificationType-${id}`, singleClassification, {
    //         shouldValidate: true,
    //       });

    //       setDisclosureData((prev) => ({
    //         ...prev,
    //         [id]: {
    //           ...prev[id],
    //           classificationType: singleClassification,
    //         },
    //       }));

    //       // disable classification dropdown
    //       setDisabledClassifications((prev) => ({ ...prev, [id]: true }));

    //       // 2) getService_Classifications => suborder types
    //       const resp2 = await getService_Classifications(
    //         lang,
    //         categoryId,
    //         subCategoryId,
    //         courtId
    //       );

    //       const subOrders = Array.isArray(resp2)
    //         ? resp2
    //         : resp2?.data || resp2?.result || [];

    //       setSuborderTypeOptions((prev) => ({ ...prev, [id]: subOrders }));

    //       // If only 1 suborder -> auto select + disable
    //       if (subOrders.length === 1) {
    //         const onlySubOrder = subOrders[0];

    //         setValue(`suborderType-${id}`, onlySubOrder, {
    //           shouldValidate: true,
    //         });

    //         setDisclosureData((prev) => ({
    //           ...prev,
    //           [id]: {
    //             ...prev[id],
    //             suborderType: onlySubOrder,
    //           },
    //         }));

    //         setDisabledSuborderTypes((prev) => ({ ...prev, [id]: true }));
    //       } else {
    //         setDisabledSuborderTypes((prev) => ({ ...prev, [id]: false }));
    //       }
    //     } else {
    //       // Multiple classifications -> keep enabled
    //       setDisabledClassifications((prev) => ({ ...prev, [id]: false }));
    //       setDisabledSuborderTypes((prev) => ({ ...prev, [id]: false }));
    //     }
    //   } catch (err) {
    //     console.error("handleOrderTypeChange error:", err);

    //     setClassificationOptions((prev) => ({ ...prev, [id]: [] }));
    //     setSuborderTypeOptions((prev) => ({ ...prev, [id]: [] }));

    //     setDisabledClassifications((prev) => ({ ...prev, [id]: false }));
    //     setDisabledSuborderTypes((prev) => ({ ...prev, [id]: false }));
    //   }
    // };

    const handleOrderTypeChange = async (id, selectedOption) => {
      if (!selectedOption) return;

      const categoryId = selectedOption.id;
      const courtId = sharedValues?.court?.id;

      // 1) Reset dependent values (form + state)
      setValue(`classificationType-${id}`, null);
      setValue(`suborderType-${id}`, null);

      setDisclosureData((prev) => ({
        ...prev,
        [id]: {
          ...prev[id],
          orderType: selectedOption,
          classificationType: null,
          suborderType: null,
        },
      }));

      // 2) Clear old options
      setClassificationOptions((prev) => ({ ...prev, [id]: [] }));
      setSuborderTypeOptions((prev) => ({ ...prev, [id]: [] }));

      // 3) Disable while loading
      setDisabledClassifications((prev) => ({ ...prev, [id]: true }));
      setDisabledSuborderTypes((prev) => ({ ...prev, [id]: true }));

      // 4) Loading flags
      setLoadingClassifications((prev) => ({ ...prev, [id]: true }));
      setLoadingSuborderTypes((prev) => ({ ...prev, [id]: false }));

      // Court is required to load classifications
      if (!courtId) {
        setLoadingClassifications((prev) => ({ ...prev, [id]: false }));
        return;
      }

      try {
        // 5) Load classifications
        const res = await getsub_categories(lang, categoryId, courtId);
        const subCats = Array.isArray(res)
          ? res
          : res?.data || res?.result || [];

        setClassificationOptions((prev) => ({ ...prev, [id]: subCats }));

        // Enable classification only if options exist
        setDisabledClassifications((prev) => ({
          ...prev,
          [id]: subCats.length === 0,
        }));

        // 6) Auto select if only 1 classification
        if (subCats.length === 1) {
          const singleClassification = subCats[0];

          setValue(`classificationType-${id}`, singleClassification, {
            shouldValidate: true,
          });

          setDisclosureData((prev) => ({
            ...prev,
            [id]: {
              ...prev[id],
              classificationType: singleClassification,
            },
          }));

          // lock classification if auto selected
          setDisabledClassifications((prev) => ({ ...prev, [id]: true }));

          // 7) Load suborder types for the auto-selected classification
          setLoadingSuborderTypes((prev) => ({ ...prev, [id]: true }));

          const resp2 = await getService_Classifications(
            lang,
            categoryId,
            singleClassification.id,
            courtId,
          );

          const subOrders = Array.isArray(resp2)
            ? resp2
            : resp2?.data || resp2?.result || [];

          setSuborderTypeOptions((prev) => ({ ...prev, [id]: subOrders }));

          // Enable suborder only if options exist
          setDisabledSuborderTypes((prev) => ({
            ...prev,
            [id]: subOrders.length === 0,
          }));

          // 8) Auto select if only 1 suborder
          if (subOrders.length === 1) {
            const onlySubOrder = subOrders[0];

            setValue(`suborderType-${id}`, onlySubOrder, {
              shouldValidate: true,
            });

            setDisclosureData((prev) => ({
              ...prev,
              [id]: {
                ...prev[id],
                suborderType: onlySubOrder,
              },
            }));

            // lock suborder if auto selected
            setDisabledSuborderTypes((prev) => ({ ...prev, [id]: true }));
          }
        }
      } catch (err) {
        console.error("handleOrderTypeChange error:", err);

        setClassificationOptions((prev) => ({ ...prev, [id]: [] }));
        setSuborderTypeOptions((prev) => ({ ...prev, [id]: [] }));

        // remain disabled if error
        setDisabledClassifications((prev) => ({ ...prev, [id]: true }));
        setDisabledSuborderTypes((prev) => ({ ...prev, [id]: true }));
      } finally {
        setLoadingClassifications((prev) => ({ ...prev, [id]: false }));
        setLoadingSuborderTypes((prev) => ({ ...prev, [id]: false }));
      }
    };

    // FULL: handleClassificationChange
    // const handleClassificationChange = async (id, selectedOption) => {
    //   if (!selectedOption) return;

    //   const orderType = disclosureData[id]?.orderType || requestId;
    //   const categoryId = orderType?.id || orderType; // supports object or id
    //   const courtId = sharedValues?.court?.id || 0;

    //   // Reset suborder (form + state) + disable flag
    //   setValue(`suborderType-${id}`, null);

    //   setDisclosureData((prev) => ({
    //     ...prev,
    //     [id]: {
    //       ...prev[id],
    //       classificationType: selectedOption,
    //       suborderType: null,
    //     },
    //   }));

    //   setSuborderTypeOptions((prev) => ({ ...prev, [id]: [] }));
    //   setDisabledSuborderTypes((prev) => ({ ...prev, [id]: false }));

    //   if (!categoryId || !courtId) return;

    //   try {
    //     const response = await getService_Classifications(
    //       lang,
    //       categoryId,
    //       selectedOption.id,
    //       courtId
    //     );

    //     const subOrders = Array.isArray(response)
    //       ? response
    //       : response?.data || response?.result || [];

    //     setSuborderTypeOptions((prev) => ({ ...prev, [id]: subOrders }));

    //     // If only 1 -> auto select + disable
    //     if (subOrders.length === 1) {
    //       const onlySubOrder = subOrders[0];

    //       setValue(`suborderType-${id}`, onlySubOrder, {
    //         shouldValidate: true,
    //       });

    //       setDisclosureData((prev) => ({
    //         ...prev,
    //         [id]: {
    //           ...prev[id],
    //           suborderType: onlySubOrder,
    //         },
    //       }));

    //       setDisabledSuborderTypes((prev) => ({ ...prev, [id]: true }));
    //     } else {
    //       setDisabledSuborderTypes((prev) => ({ ...prev, [id]: false }));
    //     }
    //   } catch (error) {
    //     console.error("Error fetching suborder types:", error);
    //     setSuborderTypeOptions((prev) => ({ ...prev, [id]: [] }));
    //     setDisabledSuborderTypes((prev) => ({ ...prev, [id]: false }));
    //   }
    // };

    const handleClassificationChange = async (id, selectedOption) => {
      if (!selectedOption) return;

      const orderType = disclosureData[id]?.orderType || requestId;
      const categoryId = orderType?.id || orderType;
      const courtId = sharedValues?.court?.id || 0;

      // Reset suborder (form + state)
      setValue(`suborderType-${id}`, null);

      setDisclosureData((prev) => ({
        ...prev,
        [id]: {
          ...prev[id],
          classificationType: selectedOption,
          suborderType: null,
        },
      }));

      // Clear old suborders and disable while loading
      setSuborderTypeOptions((prev) => ({ ...prev, [id]: [] }));
      setDisabledSuborderTypes((prev) => ({ ...prev, [id]: true }));
      setLoadingSuborderTypes((prev) => ({ ...prev, [id]: true }));

      if (!categoryId || !courtId) {
        setLoadingSuborderTypes((prev) => ({ ...prev, [id]: false }));
        return;
      }

      try {
        const response = await getService_Classifications(
          lang,
          categoryId,
          selectedOption.id,
          courtId,
        );

        const subOrders = Array.isArray(response)
          ? response
          : response?.data || response?.result || [];

        setSuborderTypeOptions((prev) => ({ ...prev, [id]: subOrders }));

        // Enable only if options exist
        setDisabledSuborderTypes((prev) => ({
          ...prev,
          [id]: subOrders.length === 0,
        }));

        // Auto select if only 1
        if (subOrders.length === 1) {
          const onlySubOrder = subOrders[0];

          setValue(`suborderType-${id}`, onlySubOrder, {
            shouldValidate: true,
          });

          setDisclosureData((prev) => ({
            ...prev,
            [id]: {
              ...prev[id],
              suborderType: onlySubOrder,
            },
          }));

          // lock if auto selected
          setDisabledSuborderTypes((prev) => ({ ...prev, [id]: true }));
        }
      } catch (error) {
        console.error("Error fetching suborder types:", error);

        setSuborderTypeOptions((prev) => ({ ...prev, [id]: [] }));
        setDisabledSuborderTypes((prev) => ({ ...prev, [id]: true }));
      } finally {
        setLoadingSuborderTypes((prev) => ({ ...prev, [id]: false }));
      }
    };

    const handleSubOrderTypeChange = (id, selectedOption) => {
      updateDisclosureData(id, "suborderType", selectedOption);
    };

    const handleInquiryOptionChange = (id, selectedOption) => {
      updateDisclosureData(id, "inquiryOption", selectedOption);
    };
    const uploadDocument = (file, id) => {
      console.log("FileFile", file);
      setUploadingDisclosures((prev) => ({ ...prev, [id]: true }));
      setIsSubmitting(true);

      UploadCourtDocument(file)
        .then((res) => {
          console.log("resupdateData", res);

          // ✅ Update original disclosure
          setDisclosureData((prevData) => {
            const updated = {
              ...prevData,
              [id]: {
                ...prevData[id],
                fileUpload: res?.hash, // hash of uploaded file
                fileName: file?.name,
                fileSize: file?.size,
                selectedUploadFile: file,
                displayedImage: res?.fileUrl,
              },
            };

            // ✅ Also update cloned disclosure if it exists
            const syntheticId = Object.keys(prevData).find(
              (key) => prevData[key]?.linkedTo === id,
            );

            if (syntheticId) {
              updated[syntheticId] = {
                ...prevData[syntheticId],
                fileUpload: res.hash,
                fileName: file.name,
                fileSize: file.size,
                selectedUploadFile: file,
              };
            }

            return updated;
          });

          // ✅ Also update react-hook-form value for the original
          setValue(`fileupload-${id}`, res.hash, { shouldValidate: true });

          // Optional: set value for clone if needed
          const syntheticId = Object.keys(disclosureData).find(
            (key) => disclosureData[key]?.linkedTo === id,
          );
          if (syntheticId) {
            setValue(`fileupload-${syntheticId}`, res.hash, {
              shouldValidate: true,
            });
          }
        })
        .catch((error) => {
          console.error("Upload failed:", error);
        })
        .finally(() => {
          setIsSubmitting(false);
          setUploadingDisclosures((prev) => {
            const updated = { ...prev };
            delete updated[id];
            return updated;
          });
        });
    };

    const handleFileChange = async (id, event) => {
      const selectedFile = event.target.files[0];
      const inputElement = document.getElementById(`fileupload-${id}`);

      clearErrors(`fileupload-${id}`);

      if (!selectedFile) {
        // No file selected
        if (inputElement) inputElement.value = null;
        updateDisclosureData(id, "fileUpload", null);
        return;
      }

      const allowedTypes = [
        "image/png",
        "image/jpeg",
        "application/pdf",
        "image/jpg",
      ];
      if (!allowedTypes.includes(selectedFile.type)) {
        setError(`fileupload-${id}`, {
          type: "manual",
          message:
            lang === "en"
              ? enPhrase["lblOnlyImgAndPDF"]
              : arPhrase["lblOnlyImgAndPDF"],
        });
        if (inputElement) inputElement.value = null;
        updateDisclosureData(id, "fileUpload", null);
        return;
      }

      if (selectedFile.size > 10 * 1024 * 1024) {
        setError(`fileupload-${id}`, {
          type: "manual",
          message:
            lang === "en"
              ? enPhrase["lblRestrictedSize"]
              : arPhrase["lblRestrictedSize"],
        });
        if (inputElement) inputElement.value = null;
        updateDisclosureData(id, "fileUpload", null);
        return;
      }

      try {
        // ✅ Upload file to external API
        const formData = new FormData();
        formData.append("file", selectedFile);
        console.log("selectedFile", selectedFile);
        setSelectedUploadFile(selectedFile);
        uploadDocument(selectedFile, id);
      } catch (error) {
        console.error("File upload error:", error);
        setError(`fileupload-${id}`, {
          type: "manual",
          message: "File upload failed.",
        });
        if (inputElement) inputElement.value = null;
        updateDisclosureData(id, "fileUpload", null);
      }
    };

    const addingMultipleServices = (data) => {
      console.log("DataData", data);
      addRequests(data, lang).then(
        (res) => {
          setLoading(false);
          console.log("resupdateData", res);
          // Check if response body contains status 400
          if (res?.isSuccess) {
            setLoading(false);
            navigate("/case-overview");
          } else {
            setSomethingWentWrong(true);
            window.scrollTo({ top: 0, behavior: "smooth" });
            setLoading(false);
            return;
          }
        },
        (error) => {
          console.error("Error submitting form", error);
          setSomethingWentWrong(true);
          window.scrollTo({ top: 0, behavior: "smooth" });
          setLoading(false);
        },
      );
    };

    const onSubmit = async () => {
      setLoading(true);
      setSubmitAllRequests(true);

      try {
        // Prepare the request payload
        const requestBody = {
          requesterId: requesterInfo?.id || 0,
          courtId: sharedValues?.court?.id || 0,
          caseTypeId: sharedValues?.caseType?.id || 0,
          caseNumber: sharedValues?.caseNumber || "",
          caseYear: Number(sharedValues?.caseYear?.name) || 0,
          requesterTypeId: sharedValues?.customer?.id || 0,
          contactEmail: sharedValues?.email || "",
          // contactNumber: sharedValues?.country_code + sharedValues?.mobile || "",
          contactNumber: sharedValues?.mobile
            ? `${sharedValues?.country_code}${sharedValues?.mobile}`
            : "",
          // mobile: sharedValues?.mobile || "",
          serviceDetails: Object.entries(disclosureData).map(([id, data]) => ({
            serviceCategoryId: data.orderType ? data.orderType.id : 0,
            subServiceCategoryId: data.classificationType
              ? data.classificationType.id
              : 0,
            classficationId: data.suborderType ? data.suborderType.id : 0,
            courtDocumentHash:
              typeof data.fileUpload === "string" ? data.fileUpload : "", // Assume uploaded file returns a hash
            keyService: data.keyService === true || data.keyService === "true", // enforce boolean
            otherServiceNote: data.otherServiceNote
              ? data.otherServiceNote
              : null,
            inquiryId: data.inquiryOption ? data.inquiryOption.id : 0,
            latitude: data.latitude ? data.latitude : null,
            longitude: data.longitude ? data.longitude : null,
            makanyNumber: data.makaniLocation ? data.makaniLocation : null,
            address: data.locationName ? data.locationName : null,
            subjectDocuments: data.SubjectDocuments
              ? data.SubjectDocuments
              : null,
          })),
          // subjectDocuments: Object.entries(disclosureData)
          // .map(([id, data]) => data.fileUpload) // Collect all file uploads (hashes)
          // .filter((hash) => hash), // Filter out any undefined or null values
        };
        console.log("Submitting requestBody", requestBody);
        addingMultipleServices(requestBody);
        setLoading(true);
      } catch (error) {
        console.error("Error submitting form", error);
        setSomethingWentWrong(true);
        window.scrollTo({ top: 0, behavior: "smooth" });
        setLoading(false);
      }
    };

    useImperativeHandle(ref, () => ({
      submitForm: () => {
        handleSubmit(onSubmit)();
      },
      hasFormErrors: async () => {
        const isValid = await trigger(); // ✅ Triggers validation for all fields
        return !isValid;
      },
      scrollToFirstErrorDisclosure: async () => {
        const isValid = await trigger(); // Ensures all fields are validated

        if (isValid) return null;

        // Find first error key related to a disclosure
        const errorKeys = Object.keys(errors);
        const firstErrorKey = errorKeys.find(
          (key) =>
            key.includes("orderType") ||
            key.includes("classificationType") ||
            key.includes("suborderType") ||
            key.includes("inquiryOption") ||
            key.includes("fileupload"),
        );

        if (!firstErrorKey) return;

        // Extract disclosure ID from key: "orderType-abc123"
        const idMatch = firstErrorKey.match(/-(.*)/);
        if (idMatch && idMatch[1]) {
          const disclosureId = idMatch[1];

          //  Open the disclosure
          setOpenDisclosures((prev) => ({
            ...prev,
            [disclosureId]: true,
          }));

          // Scroll to the disclosure
          setTimeout(() => {
            const el = disclosureRefs.current[disclosureId];
            if (el) {
              el.scrollIntoView({ behavior: "smooth", block: "start" });
            }
          }, 150);

          return disclosureId;
        }
      },
    }));

    const CustomDropdownIndicator = (props) => {
      return (
        <components.DropdownIndicator {...props}>
          <img
            src="/assets/img/add-request/dropDownArrow.svg"
            alt=""
            className=""
          />
        </components.DropdownIndicator>
      );
    };
    const openDeleteModal = (id) => {
      setSelectedDisclosureId(id);
      setModalOpen(true);
    };

    const confirmDelete = () => {
      if (selectedDisclosureId !== null) {
        removeDisclosure(selectedDisclosureId);
        setModalOpen(false);
        setSelectedDisclosureId(null);
      }
    };

    const resetDisclosureFields = (id) => {
      // Unregister fields from react-hook-form
      unregister(`orderType-${id}`);
      unregister(`classificationType-${id}`);
      unregister(`suborderType-${id}`);
      unregister(`inquiryOption-${id}`);
      unregister(`fileupload-${id}`);

      // Clear from disclosureData
      setDisclosureData((prevData) => {
        const updated = { ...prevData };
        updated[id] = {
          orderType: null,
          classificationType: null,
          suborderType: null,
          inquiryOption: null,
          fileUpload: null,
        };
        return updated;
      });

      // Reset react-hook-form values
      setValue(`orderType-${id}`, null);
      setValue(`classificationType-${id}`, null);
      setValue(`suborderType-${id}`, null);
      setValue(`inquiryOption-${id}`, null);
      setValue(`fileupload-${id}`, null);
      setSuborderTypeOptions({});
      setClassificationOptions({});
    };

    const resetDisclosureCustomFields = (id) => {
      // Unregister fields from react-hook-form

      unregister(`suborderType-${id}`);

      // Clear only suborderType, keep the rest
      setDisclosureData((prev) => ({
        ...prev,
        [id]: {
          ...prev[id],
          suborderType: null,
        },
      }));

      // Reset react-hook-form values
      setValue(`suborderType-${id}`, null);

      // setSuborderTypeOptions({});
      setClassificationOptions({});
    };

    const getClassificationStyles = (isDisabled) => ({
      ...customStyles,
      control: (base, state) => ({
        ...customStyles.control(base, state),
        backgroundColor: isDisabled ? "#ccc" : "#fff", // Light gray when disabled
        cursor: isDisabled ? "not-allowed" : "default",
      }),
    });

    // Construct displayIndexMap: { disclosureId: displayNumber }
    const displayIndexMap = {};
    let currentIndex = 1;
    disclosures.forEach((disclosure) => {
      displayIndexMap[disclosure.id] = currentIndex++;
      if (seperateRequests[disclosure.id]) {
        // Reserve a spot for the synthetic clone
        displayIndexMap[`${disclosure.id}-copy`] = currentIndex++;
      }
    });

    const resetAllDisclosures = () => {
      disclosures.forEach((disclosure) => {
        const id = disclosure.id;

        // 1. Reset React Hook Form values
        setValue(`orderType-${id}`, null);
        setValue(`classificationType-${id}`, null);
        setValue(`suborderType-${id}`, null);

        // 2. Clear validation errors for these fields
        clearErrors([
          `orderType-${id}`,
          `classificationType-${id}`,
          `suborderType-${id}`,
        ]);

        // 3. Reset the local state for dropdown options
        setClassificationOptions((prev) => ({ ...prev, [id]: [] }));
        setSuborderTypeOptions((prev) => ({ ...prev, [id]: [] }));
        setDisabledClassifications((prev) => ({ ...prev, [id]: false }));
      });

      // 4. Reset the centralized disclosureData state
      setDisclosureData((prevData) => {
        const updated = { ...prevData };
        Object.keys(updated).forEach((key) => {
          updated[key] = {
            ...updated[key],
            orderType: null,
            classificationType: null,
            suborderType: null,
          };
        });
        return updated;
      });
    };

    console.log("serviceCaregories", serviceCaregories);

    return (
      <div>
        <form
          className={`w-full flex flex-col gap-[16px] xl:flex-row 2xl:gap-0 justify-between items-start ${
            modalOpen ? "pointer-events-none blur-sm" : ""
          }`}
          id="formreceipt"
          onSubmit={handleSubmit(onSubmit)}
        >
          <CaseBasicInfo
            control={control}
            errors={errors}
            lang={lang}
            enPhrase={enPhrase}
            arPhrase={arPhrase}
            isLoading={isLoading}
            isRtl={isRtl}
            isSearchable={isSearchable}
            courts={courts}
            caseTypes={caseTypes}
            years={years}
            partyTypes={partyTypes}
            sharedValues={sharedValues}
            setSharedValues={setSharedValues}
            clearErrors={clearErrors}
            register={register}
            CustomDropdownIndicator={CustomDropdownIndicator}
            customTheme={customTheme}
            customStyles={customStyles}
            formatOptionLabel={formatOptionLabel}
            optionsYear={optionsYear}
            setServiceCaregories={setServiceCaregories}
            resetAllDisclosures={resetAllDisclosures}
            setCaseTypes={setCaseTypes}
            setValue={setValue}
            setMobileNumber={setMobileNumber}
            mobileNumber={mobileNumber}
            trigger={trigger}
          />

          <div className="w-full xl:w-[792px] flex flex-col gap-[16px]">
            <div className="flex flex-col gap-[16px]">
              {disclosures?.map((disclosure, index) => (
                <DisclosureSection
                  key={disclosure.id}
                  disclosure={disclosure}
                  index={index}
                  disclosureRefs={disclosureRefs}
                  disclosures={disclosures}
                  lastDisclosureRef={lastDisclosureRef}
                  seperateRequests={seperateRequests}
                  openDisclosures={openDisclosures}
                  parentDisclosureRef={parentDisclosureRef}
                  openDeleteModal={openDeleteModal}
                  removeDisclosure={removeDisclosure}
                  displayIndexMap={displayIndexMap}
                  setOpenDisclosures={setOpenDisclosures}
                  isLoading={isLoading}
                  isRtl={isRtl}
                  isSearchable={isSearchable}
                  CustomDropdownIndicator={CustomDropdownIndicator}
                  customTheme={customTheme}
                  customStyles={customStyles}
                  serviceCaregories={serviceCaregories}
                  setSeperateRequests={setSeperateRequests}
                  clearErrors={clearErrors}
                  handleOrderTypeChange={handleOrderTypeChange}
                  states={states}
                  getClassificationStyles={getClassificationStyles}
                  disabledClassifications={disabledClassifications}
                  formatOptionLabel={formatOptionLabel}
                  handleSubOrderTypeChange={handleSubOrderTypeChange}
                  catigories={catigories}
                  handleClassificationChange={handleClassificationChange}
                  classificationOptions={classificationOptions}
                  setClassificationOptions={setClassificationOptions}
                  setDismissedTooltips={setDismissedTooltips}
                  setDismissedSharesAndBonds={setDismissedSharesAndBonds}
                  suborderTypeOptions={suborderTypeOptions}
                  keyValue={keyValue}
                  isChecked={isChecked}
                  handleCheckboxChange={handleCheckboxChange}
                  InquiryOptions={InquiryOptions}
                  handleInquiryOptionChange={handleInquiryOptionChange}
                  resetDisclosureFields={resetDisclosureFields}
                  sharedValues={sharedValues}
                  setSharedValues={setSharedValues}
                  dismissedTooltips={dismissedTooltips}
                  uploadingDisclosures={uploadingDisclosures}
                  dismissedSharesAndBonds={dismissedSharesAndBonds}
                  previewDisclosureId={previewDisclosureId}
                  resetDisclosureCustomFields={resetDisclosureCustomFields}
                  AddLocation={AddLocation}
                  register={register}
                  setShowMap={setShowMap}
                  handleLocationSelect={handleLocationSelect}
                  openMapForDisclosure={openMapForDisclosure}
                  setValue={setValue}
                  getValues={getValues}
                  setError={setError}
                  isMobileDevice={isMobileDevice}
                  setDisplayedImage={setDisplayedImage}
                  setPreviewDisclosureId={setPreviewDisclosureId}
                  setShowImage={setShowImage}
                  showImage={showImage}
                  displayedImage={displayedImage}
                  navigate={navigate}
                  handleFileChange={handleFileChange}
                  enPhrase={enPhrase}
                  arPhrase={arPhrase}
                  disclosureData={disclosureData}
                  lang={lang}
                  control={control}
                  errors={errors}
                  setDisclosureData={setDisclosureData}
                  setIsSubmitting={setIsSubmitting}
                  setIsSubmittingDocuments={setIsSubmittingDocuments}
                  disabledSuborderTypes={disabledSuborderTypes}
                  loadingClassifications={loadingClassifications}
                  loadingSuborderTypes={loadingSuborderTypes}
                />
              ))}
            </div>

            <button
              className={`flex flex-row items-center justify-center gap-[8px]  h-[44px] font-bold font-Almarai text-[14px]  bg-[#fff]  rounded-[4px] mb-[55px]  text-[#361E12] ${
                Object.keys(disclosureData)?.length >= 9
                  ? "cursor-not-allowed opacity-50"
                  : ""
              }`}
              onClick={(e) => {
                e.preventDefault(); // ✅ Prevent button from triggering form validation
                // Add new disclosure without triggering validation
                addNewDisclosure();
                setTimeout(() => {
                  // Scroll to the new disclosure
                  if (lastDisclosureRef.current) {
                    lastDisclosureRef.current.scrollIntoView({
                      behavior: "smooth",
                      block: "nearest",
                    });
                  }
                }, 100);
              }}
              disabled={Object.keys(disclosureData)?.length >= 9}
            >
              <img
                src="/assets/img/add-request/vectorAddColor.svg"
                alt="archive"
                className="w-[20px] h-[20px]"
              />
              <span className="font-Almarai font-bold text-[14px] text-[#836327] leading-[20px]">
                {lang === "en"
                  ? enPhrase["lblAddRequest"]
                  : arPhrase["lblAddRequest"]}
              </span>
            </button>
          </div>
        </form>

        {modalOpen && (
          <SharedModal
            isDeleteRequest
            setOpenModal={setModalOpen}
            openModal={modalOpen}
          >
            <div
              className="flex flex-col items-center gap-[24px] py-[32px]"
              onClick={(e) => e.stopPropagation()}
            >
              <img
                src="/assets/img/add-request/delete.svg"
                alt="delete"
                className="w-[48px] h-[48px]"
              />
              <div className="flex flex-col items-center justify-center gap-[24px] px-[32px] text-center">
                <p className="font-Almarai font-bold text-[22px] leading-[36px] text-[#E23636] ">
                  {lang === "en"
                    ? enPhrase["lblConfirmDeleteApp"]
                    : arPhrase["lblConfirmDeleteApp"]}
                </p>
                <p className="font-Almarai font-[400] text-[16px] leading-[24px] text-[#666666]">
                  {lang === "en"
                    ? enPhrase["lblDataLossWarningForApp"]
                    : arPhrase["lblDataLossWarningForApp"]}
                </p>
                <div className="w-full flex flex-col md:flex-row justify-center gap-[16px]">
                  <button
                    className="w-full md:w-[176px] h-[44px] rounded-[4px] px-[16px] bg-[#E9DCC2]"
                    onClick={() => setModalOpen(false)}
                  >
                    <p className="font-Almarai font-bold text-[14px] leading-[20px] text-[#361E12]">
                      {lang === "en"
                        ? enPhrase["lblGoBackText"]
                        : arPhrase["lblGoBackText"]}
                    </p>
                  </button>
                  <button
                    className="w-full md:w-[176px] h-[44px] rounded-[4px] px-[16px] bg-[#B68A35]"
                    onClick={confirmDelete}
                  >
                    <p className="font-Almarai font-bold text-[14px] leading-[20px] text-[#fff]">
                      {lang === "en"
                        ? enPhrase["lblDeleteRequest"]
                        : arPhrase["lblDeleteRequest"]}
                    </p>
                  </button>
                </div>
              </div>
            </div>
          </SharedModal>
        )}
      </div>
    );
  },
);

export default CaseDetailsUpdated;
